import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiButton from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";
import { useHistory } from "react-router-dom";

import { ROUTE_PATHS } from "../../../../types/RoutePaths";

type NoPaymentMethodModalProps = {
  open: boolean;
  advertiserId: string;
};

const ModalHeader = styled("div")(({ theme }: { theme: Theme }) => ({
  padding: "20px 24px",
  borderBottom: `1px solid ${theme.palette.brand.gray100}`,
  background: theme.palette.brand.white,
}));

const ModalTitle = styled(Typography)(({ theme }: { theme: Theme }) => ({
  fontSize: 16,
  fontWeight: 600,
  color: theme.palette.brand.gray900,
}));

const StyledDialogContent = styled(DialogContent)(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.gray50,
  padding: "24px !important",
  minWidth: 440,
  maxWidth: 520,
}));

const MessageText = styled(Typography)(({ theme }: { theme: Theme }) => ({
  fontSize: 14,
  color: theme.palette.brand.gray700,
  lineHeight: 1.6,
}));

const StyledDialogActions = styled(DialogActions)(({ theme }: { theme: Theme }) => ({
  padding: "16px 24px",
  borderTop: `1px solid ${theme.palette.brand.gray100}`,
  background: theme.palette.brand.white,
}));

const BackButton = styled(MuiButton)(({ theme }: { theme: Theme }) => ({
  color: theme.palette.brand.gray700,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  borderColor: theme.palette.brand.gray300,
  borderRadius: 8,
  padding: "8px 14px",
}));

const GoToSettingsButton = styled(MuiButton)(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.coral,
  color: theme.palette.brand.white,
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  borderRadius: 8,
  padding: "8px 16px",
  boxShadow: "none",
  "&:hover": {
    background: theme.palette.brand.coralHover,
    boxShadow: "none",
  },
}));

const NoPaymentMethodModal: FC<NoPaymentMethodModalProps> = ({ open, advertiserId }) => {
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  const handleGoToSettings = () => {
    history.push(ROUTE_PATHS.ADVERTISER_DETAIL.replace(":id", advertiserId));
  };

  return (
    <Dialog open={open} disableBackdropClick disableEscapeKeyDown maxWidth="sm">
      <ModalHeader>
        <ModalTitle>Payment method required</ModalTitle>
      </ModalHeader>

      <StyledDialogContent>
        <MessageText>
          No payment method is attached to this advertiser. Please add a card in the advertiser settings before creating
          a campaign.
        </MessageText>
      </StyledDialogContent>

      <StyledDialogActions>
        <BackButton variant="outlined" onClick={handleBack}>
          Back
        </BackButton>
        <GoToSettingsButton variant="contained" onClick={handleGoToSettings}>
          Go to Settings
        </GoToSettingsButton>
      </StyledDialogActions>
    </Dialog>
  );
};

export default NoPaymentMethodModal;
